import { IRole } from '@boma/client-shared';

export interface IUserBasic {
  id: string;
  firstName: string;
  surname: string;
}

export interface IUser extends IUserBasic {
  roles: IRole[];
  supplierPermissions?: ISupplierPermission[];
  updatedAt: Date;
  createdAt: Date;
}

export interface IUserAPIResponse {
  user: {
    id: string;
    firstName: string;
    surname: string;
    idNumber: string;
    occupation: string;
    gender: string;
    dateOfBirth: string;
    fullName: string;
  };
  identificationNumber: string;
  employeeNumber: string;
  position: string;
  companyEmail: string;
  companyContactNumber: string;
  personalContactNumber: string;
  department: string;
  notes: string;
}

export interface ISupplierPermission {
  supplierId: string;
  permissions: string[];
}

export interface IUserEntity {
  id: string;
  firstName: string;
  surname: string;
  roles: IRole[];
  selectedOrganizationId?: string;
  entities?: IUserEntityPermission[];
  updatedAt: Date;
  createdAt: Date;
}

export interface IUserEntityPermission {
  id: string;
  permissions: string[];
}

export interface IEntityUser {
  user: IUserAccount;
  identificationNumber: string;
  employeeNumber: string;
  position: number;
  companyContactNumber: string;
  personalContactNumber: string;
  department: string;
  notes: string;
  userId: string;
  vehicleRoles: IGenericRole[];
  entityRoles: IGenericRole[];
  locationRoles: IGenericRole[];
}

// Used when confirming that a user is registered on the system
export interface IUserAccount {
  fullName?: string;
  id: string;
  firstName: string;
  surname: string;
  bomaContactNumber: string;
}

export interface IGenericRole {
  target: string;
  targetId: string;
  roles: IRole[];
}
